import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Table, Popup } from "semantic-ui-react";

import ResourceIcon from "../resources/resourceIcon/ResourceIcon.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

import { ALL_RESOURCE_KEYS } from "../../constants/entity.js";

class LimitTable extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired
  };

  renderLimitRow = resourceKey => {
    const {
      data: { limits },
      copy
    } = this.props;

    if (!limits[resourceKey]) return null;

    const max = get(limits, `${resourceKey}.maximum`);
    const used = get(limits, `${resourceKey}.used`);

    const name = copy(`resource_types.plural.${resourceKey.toLowerCase()}`);
    const error = used >= max ? true : false;
    const warning = !error && used / max >= 0.9 ? true : false;
    const messageCopyKey = error ? "error_message" : "warning_message";

    const row = (
      <Table.Row error={error} warning={warning} key={resourceKey}>
        <Table.Cell>
          <ResourceIcon
            data={{
              "@type": resourceKey,
              name
            }}
            disabled={true}
          />
        </Table.Cell>
        <Table.Cell collapsing>{max}</Table.Cell>
        <Table.Cell collapsing>{used}</Table.Cell>
      </Table.Row>
    );

    if (warning || error) {
      return (
        <Popup
          key={resourceKey}
          trigger={row}
          position="top right"
          inverted
          flowing
          size="tiny"
          content={copy(`account.limits.${messageCopyKey}`)}
        />
      );
    }

    return row;
  };

  renderLimitRows = () => {
    return ALL_RESOURCE_KEYS.map(key => {
      return this.renderLimitRow(key);
    });
  };

  render() {
    const { copy } = this.props;

    return (
      <Table celled unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              {copy("account.limits.resource_type")}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {copy("account.limits.maximum")}
            </Table.HeaderCell>
            <Table.HeaderCell>{copy("account.limits.used")}</Table.HeaderCell>
          </Table.Row>
          {this.renderLimitRows()}
        </Table.Header>
      </Table>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(LimitTable);
